import Loadable from 'react-loadable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import formActions from '@/redux/intakeForm/actions';
import modalsActions from '@/redux/modals/actions';
import { Loader } from '@/components';

const AsyncIntakeForm = Loadable({
  loader: () => import('./IntakeForm'),
  loading: Loader,
});

const mapStateToProps = ({ intakeForm, modals }) => ({
  stepsData: intakeForm.stepsData,
  stepIndex: intakeForm.stepIndex,
  isFetching: intakeForm.isFetching,
  isLeadCreated: intakeForm.isLeadCreated,
  lead: intakeForm.lead,
  countryCode: '+1',
  isUAPIIframeModalOpen: modals.isUAPIIframeModalOpen,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fileUpload: formActions.fileUpload,
      fileRemove: formActions.fileRemove,
      submitForm: formActions.submitForm,
      nextSubmit: formActions.nextSubmit,
      prevStep: formActions.prevStep,
      utilityApiAuth: formActions.utilityApiAuth,
      saveStepData: formActions.saveStepData,
      toggleUapiIframeModal: modalsActions.toggleUapiIframeModal,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(AsyncIntakeForm);
